import { CalculationStates } from '@/interfaces'

export const calculationStatusDictionary = {
  [CalculationStates.NotSet]: 'New',
  [CalculationStates.InProgress]: 'Calculating',
  [CalculationStates.Finished]: 'Completed',
  [CalculationStates.Error]: 'Failed',
  [CalculationStates.Preprocessing]: 'Processing',
  [CalculationStates.Canceled]: 'Canceled'
} as const

export const calculationStatuses = [
  CalculationStates.NotSet,
  CalculationStates.Preprocessing,
  CalculationStates.InProgress,
  CalculationStates.Error,
  CalculationStates.Finished,
  CalculationStates.Canceled
].map(state => ({
  title: calculationStatusDictionary[state] || 'Unknown',
  state
}))
